import React, {ReactElement, useContext} from 'react';
import {AuthContext, AuthInformation} from './AuthContext';
import {LoginPane} from "./LoginPane";

export type signinCallbackType = (authInformation: AuthInformation) => void;

interface ProtectedRouteProps {
    signinCallback: signinCallbackType;
    children: ReactElement;
}

export const ProtectedRoute: React.FunctionComponent<ProtectedRouteProps> = ({ children, signinCallback }): ReactElement => {
    const authState = useContext(AuthContext);
    return authState.sessionId ? children : <LoginPane using={signinCallback}/>
}